import { render } from "./ButtonPrev.vue?vue&type=template&id=18548f30&scoped=true"
import script from "./ButtonPrev.vue?vue&type=script&lang=js"
export * from "./ButtonPrev.vue?vue&type=script&lang=js"

import "./ButtonPrev.vue?vue&type=style&index=0&id=18548f30&scoped=true&lang=css"

import exportComponent from "F:\\CodeBrix\\My Porter\\WECCO-UserFlow\\MyPorter\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18548f30"]])

export default __exports__